import React from 'react';
import { View, TouchableOpacity, StyleSheet, Text } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { colors, spacing, fontSizes } from '../styles/theme';

interface StarRatingProps {
  rating: number;
  onRatingChange: (rating: number) => void;
  size?: number;
  showLabel?: boolean;
}

export const StarRating: React.FC<StarRatingProps> = ({
  rating,
  onRatingChange,
  size = 24,
  showLabel = true,
}) => {
  const stars = [1, 2, 3, 4, 5];

  const getRatingLabel = (rating: number): string => {
    if (rating === 0) return 'No rating';
    if (rating === 1) return 'Poor';
    if (rating === 2) return 'Fair';
    if (rating === 3) return 'Good';
    if (rating === 4) return 'Very Good';
    if (rating === 5) return 'Excellent';
    return '';
  };

  return (
    <View style={styles.container}>
      <View style={styles.starsContainer}>
        {stars.map((star) => (
          <TouchableOpacity
            key={star}
            onPress={() => onRatingChange(star)}
            style={styles.starButton}
            accessibilityLabel={`Rate ${star} star${star > 1 ? 's' : ''}`}
          >
            <Ionicons
              name={star <= rating ? 'star' : 'star-outline'}
              size={size}
              color={star <= rating ? colors.warning : colors.gray300}
            />
          </TouchableOpacity>
        ))}
      </View>
      {showLabel && (
        <Text style={styles.ratingLabel}>
          {getRatingLabel(rating)}
        </Text>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
  },
  starsContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: spacing.xs,
  },
  starButton: {
    padding: spacing.xs,
    marginHorizontal: 2,
  },
  ratingLabel: {
    fontSize: fontSizes.sm,
    color: colors.gray500,
    fontWeight: '500',
  },
}); 
